// assets/custom-empaque.js
(function () {
  const EMPAQUE_VARIANT_ID = 51526993019175;
  let isProcessing = false;

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addEmpaque() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: EMPAQUE_VARIANT_ID, quantity: 1 })
    });
  }

  async function removeEmpaque() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [EMPAQUE_VARIANT_ID]: 0 } })
    });
  }

  // ── Forzar cantidad exacta de 1 empaque ───────────────────────────────────
  async function fixEmpaqueQuantity() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [EMPAQUE_VARIANT_ID]: 1 } })
    });
  }

  async function notifyHorizon(cart) {
    try {
      const { CartUpdateEvent } = await import('@theme/events');
      const event = new CartUpdateEvent(cart, '', {
        itemCount: cart.item_count,
        source: 'empaque-sync',
        sections: {}
      });
      document.dispatchEvent(event);
    } catch (e) {
      console.warn('[Empaque] No se pudo notificar a Horizon:', e);
    }
  }

  async function syncEmpaque() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const cart      = await getCart();
      const items     = cart.items || [];
      const empaque   = items.find(i => i.variant_id === EMPAQUE_VARIANT_ID);
      const realItems = items.filter(i => i.variant_id !== EMPAQUE_VARIANT_ID);

      if (realItems.length > 0 && !empaque) {
        // No hay empaque → agregar
        const res = await addEmpaque();
        if (res.ok) {
          const updatedCart = await getCart();
          await notifyHorizon(updatedCart);
        }
      } else if (realItems.length > 0 && empaque && empaque.quantity > 1) {
        // Hay más de 1 empaque → corregir a 1
        const res = await fixEmpaqueQuantity();
        if (res.ok) {
          const updatedCart = await getCart();
          await notifyHorizon(updatedCart);
        }
      } else if (realItems.length === 0 && empaque) {
        // Carrito vacío real → quitar empaque
        const res = await removeEmpaque();
        if (res.ok) {
          const updatedCart = await getCart();
          await notifyHorizon(updatedCart);
        }
      }

    } catch (err) {
      console.error('[Empaque] Error en sync:', err);
    } finally {
      isProcessing = false;
    }
  }

  // ── Interceptor de fetch ──────────────────────────────────────────────────
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const url = typeof args[0] === 'string'
      ? args[0]
      : (args[0]?.url || '');

    const isCartMutation = /\/cart\/(add|change|update|clear)/.test(url);
    const promise = originalFetch.apply(this, args);

    if (isCartMutation) {
      promise
        .then(() => setTimeout(syncEmpaque, 500))
        .catch(() => {});
    }

    return promise;
  };

  // ── Ocultar controles del empaque con delay para esperar re-render ─────────
  function hideEmpaqueControls() {
    // Doble disparo: inmediato y con delay para cubrir el re-render de Horizon
    _hideControls();
    setTimeout(_hideControls, 300);
  }

  function _hideControls() {
    document.querySelectorAll('cart-items-component tr').forEach(row => {
      const variantInput = row.querySelector('[data-variant-id="51526993019175"]');
      if (!variantInput) return;

      const quantitySelector = row.querySelector('quantity-selector-component');
      const removeButton = row.querySelector('.cart-items__remove');

      if (quantitySelector) quantitySelector.style.display = 'none';
      if (removeButton) removeButton.style.display = 'none';
    });
  }

  // ── MutationObserver ──────────────────────────────────────────────────────
  const observer = new MutationObserver(hideEmpaqueControls);

  document.addEventListener('DOMContentLoaded', () => {
    syncEmpaque();
    hideEmpaqueControls();

    const cartItems = document.querySelector('cart-items-component');
    if (cartItems) {
      observer.observe(cartItems, { childList: true, subtree: true });
    }
  });

// ── Reemplazar botón "Comprar ahora" con uno propio ───────────────────────
  function replaceBuyNowButton() {
    document.querySelectorAll('.shopify-payment-button').forEach(container => {
      if (container.dataset.empaqueReplaced) return;
      container.dataset.empaqueReplaced = 'true';

      // Ocultar el botón original de Shopify
      container.style.display = 'none';

      // Crear botón propio con el mismo estilo
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = 'Comprar ahora';
      btn.className = 'shopify-payment-button__button shopify-payment-button__button--unbranded';
      btn.style.width = '100%';
      btn.style.borderRadius = 'var(--style-border-radius-buttons-primary)';

      btn.addEventListener('click', async () => {
        btn.disabled = true;
        btn.textContent = 'Procesando...';

        try {
          // Obtener variant ID del formulario de producto
          const form = container.closest('form') || document.querySelector('form[action="/cart/add"]');
          const variantInput = form?.querySelector('[name="id"]');
          const variantId = variantInput?.value;
          const quantity = form?.querySelector('[name="quantity"]')?.value || 1;

          if (!variantId) throw new Error('Variant no encontrado');

          // Agregar producto al carrito
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) })
          });

          // Agregar empaque si no está
          const cart = await getCart();
          const empaque = cart.items.find(i => i.variant_id === EMPAQUE_VARIANT_ID);
          if (!empaque) await addEmpaque();

          // Redirigir al checkout
          window.location.href = '/checkout';

        } catch (err) {
          console.error('[Empaque] Error en Buy Now propio:', err);
          btn.disabled = false;
          btn.textContent = 'Comprar ahora';
        }
      });

      // Insertar botón después del contenedor original
      container.insertAdjacentElement('afterend', btn);
    });
  }

  document.addEventListener('DOMContentLoaded', replaceBuyNowButton);
  const buyNowObserver = new MutationObserver(replaceBuyNowButton);
  document.addEventListener('DOMContentLoaded', () => {
    buyNowObserver.observe(document.body, { childList: true, subtree: true });
  });
})();